import { AuthService } from './auth.service';
import { UserService } from './user.service';
import {AuthGuardService } from './auth-guard.service';

export const services = [AuthService, UserService, AuthGuardService];

export * from './auth.service';
export * from './user.service';
